import { render, staticRenderFns } from "./QueryHome.vue?vue&type=template&id=42c4f018&scoped=true&"
import script from "./QueryHome.vue?vue&type=script&lang=js&"
export * from "./QueryHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c4f018",
  null
  
)

export default component.exports